import {collectSuggestedFieldKeys} from './workforceProfileWizardValidation';
import type {ResearchWorkforceProfileDraftResponse} from '../../../../../lib/api/RequestBodies/features/company/workforce/WorkforceProfileRequestBodies';
import type {WorkforceProfileAnalysisDataInput} from '../../types/workforceProfileDetailsTypes';

export const mergeResearchDraftResponse = (
  response: ResearchWorkforceProfileDraftResponse
): {
  analysisInput: WorkforceProfileAnalysisDataInput;
  suggestedFieldKeys: string[];
  gapsOrAmbiguities: string[];
} => {
  const mapped = response.profileAnalysisDataInput;

  const gapsOrAmbiguities = [
    ...(mapped.gapsOrAmbiguities ?? []),
    ...(response.researchMetadata?.gapsOrAmbiguities ?? []),
  ];

  return {
    analysisInput: {
      ...mapped,
      gapsOrAmbiguities,
    },
    suggestedFieldKeys: collectSuggestedFieldKeys(mapped),
    gapsOrAmbiguities,
  };
};
